import { render } from "./CheckBox.vue?vue&type=template&id=5f414826&ts=true"
import script from "./CheckBox.vue?vue&type=script&lang=ts"
export * from "./CheckBox.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__